import React, { useEffect, useState } from 'react'
import './index.scss'

function NotFound() {
  return (
    <div className="not-found">
      Página não encontrada
    </div>
  )
}

export default NotFound
